export default __webpack_public_path__ + "static/media/803.a5f74735.png";